<template>
  <div>
    <Card>
      <template #title>{{ title ?? 'Удаленные события' }}</template>
      <template #content>
        <AbstractTable code="deleteEvents" ref="dataTable" :default-data="defaultData" display-filter="menu">
          <template #additionalButtons>
            <Button
              icon="pi pi-refresh"
              class="p-button-rounded p-button-outlined"
              @click="$refs.dataTable.getData()"
            ></Button>
          </template>
          <template #id="row">
            <IdChip
              :id="row.data.id"
              :menu-items="generateItems(row.data)"
              toast-template='ID события "{v}" скопирован'
            />
          </template>
          <template #reportId="row">
            <IdChip
              v-if="row.data.reportId"
              :id="row.data.reportId"
              view="delete_report_view"
              toast-template='Идентификатор отчёта "{v}" скопирован'
            />
          </template>
          <template #loanId="row">
            <ValueChip
              :value="row.data.loanId"
              toast-template='Идентификатор займа "{v}" скопирован'
            />
          </template>
          <template #cbUuid="row">
            <ValueChip
              :value="row.data.cbUuid"
              toast-template='ЦБ УИД "{v}" скопирован'
            />
          </template>
        </AbstractTable>
      </template>
    </Card>
  </div>
</template>

<script>
import AbstractTable from "@/components/AbstractTable.vue";
import ValueChip from "@/components/Common/ValueChip.vue";
import IdChip from "@/components/Common/IdChip.vue";
import DeleteReportsTableDialog from "@/components/Dialog/DeleteReportsTableDialog.vue";

export default {
  name: 'DeleteEventsTable',
  components: {IdChip, AbstractTable, ValueChip},
  props: {
    title: {
      type: String,
      default: () => null
    },
    defaultData: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    generateItems(data) {
      return [
        {
          label: 'Отчёты с этой заявкой',
          icon: 'pi pi-fw pi-list',
          command: () => this.showRelatedReports(data),
        }
      ]
    },
    showRelatedReports(data) {
      this.$dialog.open(DeleteReportsTableDialog, {
        data: {
          deleteEventId: data.id
        },
        props: {
          style: {
            width: '100%',
            maxWidth: '1400px'
          },
          header: `Отчёты на удаление КИ с заявкой '${data.applicationUuid}'`,
          modal: true,
          closable: true,
          dismissableMask: true
        }
      })
    }
  }
}
</script>
